var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  points: "33.1,28.1 28.1,28.1 33.1,33.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  points: "11.9,33.1 16.8,28.1 11.9,28.1  "
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M34.1,27.9h3.1c0.1-0.1,0.1-0.3,0.1-0.4V8.1c0-0.2,0-0.3-0.1-0.4l-0.4-0.1h-29C7.6,7.8,7.6,7.9,7.6,8.1 v19.5c0,0.1,0,0.3,0.1,0.4h3.1v8.2H8.1c-0.2,0-0.5,0.2-0.5,0.4c0,0.3,0.2,0.5,0.5,0.5h6.5c0.3,0,0.5-0.2,0.5-0.5 c0-0.2-0.3-0.4-0.5-0.4h-2.8v-2l6.2-6.2h8.8l6.2,6.2v2h-2.8c-0.2,0-0.5,0.2-0.5,0.4c0,0.3,0.2,0.5,0.5,0.5h6.5 c0.3,0,0.5-0.2,0.5-0.5c0-0.2-0.3-0.4-0.5-0.4h-2.7V27.9z M11.9,33.1v-4.9h4.9L11.9,33.1z M8.6,27.1V8.6h27.7v18.6H8.6z M28.1,28.1 h4.9v4.9L28.1,28.1z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 8.6,
  y: 8.6,
  fill: "#FFFFFF",
  width: 27.7,
  height: 18.6
}));

function SvgWhiteboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteboard);
export default __webpack_public_path__ + "static/media/whiteboard.bc53a2a9227bab4bf697e0b4317eac04.svg";
export { ForwardRef as ReactComponent };